/* ashraf 10/03/2022 2699761741 fixed event tactic route issue
sohel  10/12/2022 2699761741 Triggers ,Trigger Group ->Added breadcrumbs,label changes,pagination changes
sohel  10/15/2022 2699761741 Triggers -> Added Code Comments
sohel  10/17/2022 2699761741 Trigger and Trigger Group fixed validation issue ,added tooltip and label changes.
akhila 10/18/2022 2699761741 search Triggers -> changed code filed to drop down and search triggers payload.
Rohini 10/27/2022 2699761741 search Triggers -> Added classnames and modified the styles in text feilds, buttons.
Raghu 10/28/2022 2699761741 Input Field Alignment Fixes
Prakash 10/30/2022  2699761741 Added class for Fields.
Suresh Peddavoora 11/03/2022 2699761741 Text fields Tab Responsive Fixes
Lalitha 11/08/2022 2699761741 Added Autocomplete TextField
Prakash Gummala 14/10/2022 2699761741 Text Field Alignments for 768-1024px resolution.
Sohel 11/14/2022 2699818958 Implemented run functionality
Gummala Prakash 11/17/2022 2699761741 Fixed Button Responsiveness.
akhila 11/18/2022 2699761741 Change Trigger code field from autoComplete to TextField
Guru Prasad 11/24/2022 2699761741 fixed input fields responsive for tablet and laptop
Akhila 12/08/2022 2699761741 added session storage for search items
lalitha 12/09/2022 2699761741 Added Created Date Field
Raghu 12/09/2022 2699761741 Field Responsive Alignment Fixes
Raghu 12/12/2022 2699761741 Button Alignment fixes
Akhila 12/15/2022 2699761741 bug fix session search
Prakash Gummala 12/20/2022 2699761741 inputfield Alignments  for tab and desktop resolution.
Ashraf 12/20/2022 2699761741 fixed user role access
Dilip 01/05/2023 2699761741 removed mode field
Dilip 02/13/2023 2699761741 created by dropdoen changes
sai krishna 02/13/2023 2699761741 added client code field in
Raghu 02/21/2023 2699761741 changed text feilds colors
Raghu 02/28/2023 2699761741 fixed alignments
Prakash 03/28/2023 2699761741 fixed inputfiled alignments issue.
Ravi 04/13/2023 3031450488 Added event type in search
Ravi  04/19/2023 2699761741  modified client code dropDownData data
Prakash 04/26/2023 2699761741 fixed issue in tab view
Prakash 08/05/2023 2699761741 add theming classname.
Akhila 06/08/2023 2699761741 created date change to date created field and column
Ravi  06/08/2023 2699761741  rearrange search fields */

import React, {useEffect, useState, useContext} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Form, Formik} from 'formik';
import {Button, Grid, TextField, FormHelperText} from '@material-ui/core';
import ErrorBoundaryForComponents from '../../../../util/ErrorBoundaryForComponents';
import EventTacticSearchTable from './EventTacticSearchTable';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import {
  ResetMessage as resetMessage,
  ResetStatus as resetStatus,
  fetchDispositionCodes,
} from '../../../../redux/reducers/EventTactics/EventTactics';
import DialogBox from '../../../../components/DialogBox';
import ConfirmationForm from './ConfirmationForm';
import {
  fetchEventTacticsExecute,
  fetchAllTriggerCode,
} from '../../../../redux/reducers/EventTactics/EventTactics';
import * as Yup from 'yup';
import {
  fetchCreatedByDropDownData,
  getAllReportCreatedForData,
} from '../../../../redux/reducers/ReportMaster';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import GuiAutoComplete from '../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../components/FormComponents/GuiTextField';
import {getClientCodeDropDownData} from '../../../../redux/reducers/TriggerGroup';
import {EVENT_ACTION} from '../../../../constants/Lookup';
import {getOptions} from '../../../../util/GetDropDownOptions';
import {createdByOptions} from '../../../../util/CreatedByForOptions';

const SearchEventContainer = ({
  setValue,
  setEventTacticCode,
  roleDataEvent,
  setIsCopyIcon,
  setRowSelected,
  setTriggerMaintenanceData = () => {},
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [searchData, setSearchData] = useState({});
  const [submit, setSubmit] = useState(false);
  const [runClicked, setRunClicked] = useState(false);
  const [mainRunClicked, setMainRunClicked] = useState(false);

  const [rowDataCode, setRowDataCode] = useState('');
  const {clientCodeDropdownData} = useSelector(({addTriggerGroup}) => addTriggerGroup);
  const dispatch = useDispatch();

  const StatusOptions = [
    {key: 'Y', value: 'Draft'},
    {key: 'N', value: 'Completed'},
  ];

  // set search data(2699761741)
  const handleSubmit = (data) => {
    setSearchData(data);
    setSubmit(true);
    sessionStorage.setItem('searchTrigger', JSON.stringify(data));
  };
  const {addEventTacticStatus, dispositionDropDown} = useSelector(
    ({addEventTactic}) => addEventTactic,
  );
  const {createdByData} = useSelector(({reportMaster}) => reportMaster);

  const searchsessionTrigger = JSON.parse(sessionStorage.getItem('searchTrigger'));

  // form initial values(2699761741)
  const initialValues = {
    code: '',
    description: '',
    mode: '',
    isDraft: '',
    createdBy: '',
    createdDate: null,
    clientCode: '',
    event: '',
  };

  // form field validation(2699761741)
  const schema = Yup.object().shape({
    createdDate: Yup.date().typeError('Invalid date format').nullable(),
  });

  // reset Data(2699761741)
  useEffect(() => {
    if (addEventTacticStatus === 200 || addEventTacticStatus === 500) {
      setTimeout(() => {
        dispatch(resetMessage());
        dispatch(resetStatus());
      }, 3000);
    }
  }, [addEventTacticStatus]);
  useEffect(() => {
    dispatch(getClientCodeDropDownData());
  }, []);

  // set Copy state(2699767208)
  useEffect(() => {
    setIsCopyIcon(false);
    dispatch(fetchAllTriggerCode());
  }, []);

  // reset Form data (2699761741)
  const onClear = () => {
    const data = {
      code: '',
      description: '',
      mode: '',
      isDraft: '',
      createdDate: null,
      clientCode: '',
      event: '',
    };
    setSearchData(data);
  };

  // Run Report(2699818958)
  useEffect(() => {
    if (mainRunClicked) {
      dispatch(
        fetchEventTacticsExecute({
          code: rowDataCode,
          parameters: [],
        }),
      );
      setRowDataCode('');
      setMainRunClicked(false);
    }
  }, [mainRunClicked, rowDataCode]);
  useEffect(() => {
    dispatch(getAllReportCreatedForData());
    dispatch(fetchCreatedByDropDownData('triggermaintaince'));
    dispatch(fetchDispositionCodes());
  }, []);
  // closed run report dialog box(2699818958)
  const closeDialog = () => {
    setRunClicked(false);
  };
  return (
    <>
      <div>
        <h2 className="search-title">Trigger Maintenance Search</h2>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={searchsessionTrigger ? searchsessionTrigger : initialValues}
          validationSchema={schema}
          enableReinitialize
        >
          {(props) => {
            const {touched, errors, values, handleChange, resetForm, handleBlur, setFieldValue} =
              props;
            return (
              <div className={classes.ruleGroupCard}>
                <Form autoComplete="off" noValidate>
                  <div>
                    <ErrorBoundaryForComponents>
                      <Grid
                        className=" new-standard-textfields align-items-center"
                        container
                        spacing={2}
                      >
                        <Grid
                          item
                          xs={6}
                          md={4}
                          lg={3}
                          xl={3}
                          className="form-group account-guarantor"
                        >
                          {/* changed TextField to dropdown field(2699761741) */}
                          {/* <Autocomplete
                            classes={{
                              popper: classes.popper,
                              option: classes.option,
                            }}
                            id="code"
                            size="small"
                            options={allTriggerCode?.length > 0 ? allTriggerCode : []}
                            getOptionLabel={(option) => {
                              return option && option?.code ? option?.code : "";
                            }}

                            renderInput={(params) => (
                              <div className="select-field"> */}
                          <TextField
                            className={` ${classes.labelName}`}
                            variant="outlined"
                            margin="dense"
                            name="code"
                            // InputLabelProps={{ shrink: true }}
                            label="Trigger Name"
                            value={values.code}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder={`Enter Trigger Name`}
                            fullWidth
                          />
                          {/* </div> */}
                          {/* )} */}
                          {/* /> */}
                        </Grid>
                        <Grid
                          item
                          xs={6}
                          md={4}
                          lg={3}
                          xl={3}
                          className="form-group account-guarantor"
                        >
                          <TextField
                            className={` ${classes.labelName}`}
                            margin="dense"
                            variant="outlined"
                            name="description"
                            placeholder={`Enter Trigger Description`}
                            label="Trigger Description"
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            value={values.description}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            fullWidth
                          />
                        </Grid>
                        <Grid
                          item
                          xs={6}
                          md={4}
                          lg={3}
                          xl={3}
                          className="form-group account-guarantor"
                        >
                          <GuiAutoComplete
                            classes={{
                              // popper: classes.popper,
                              option: classes.option,
                            }}
                            name="event"
                            id="event"
                            size="small"
                            value={values.event}
                            options={getOptions(EVENT_ACTION, dispositionDropDown)}
                            getOptionLabel={(option) => {
                              return option && option.value ?
                                option.valueCode === null ?
                                  option.value :
                                  option.value :
                                '';
                            }}
                            onChange={(e, value) => {
                              handleChange(e);
                              setFieldValue('event', value);
                            }}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  className={` ${classes.labelName}`}
                                  {...params}
                                  variant="outlined"
                                  margin="dense"
                                  // InputLabelProps={{
                                  //   shrink: true,
                                  // }}
                                  label="Event"
                                  placeholder="Select Event"
                                />
                              </div>
                            )}
                          />
                        </Grid>
                        <Grid
                          item
                          xs={6}
                          md={4}
                          lg={3}
                          xl={3}
                          className="form-group account-guarantor"
                        >
                          <GuiAutoComplete
                            classes={{
                              popper: classes.popper,
                              option: classes.option,
                            }}
                            name="clientCode"
                            id="clientCode"
                            size="small"
                            value={values.clientCode}
                            options={clientCodeDropdownData || []}
                            getOptionLabel={(option) => {
                              return option && option.clientName ? option.clientName : '';
                              // ? option.clientNumber === null
                              //   ? option.clientName
                              //   : option.clientNumber + " - " + option.clientName
                              // : "";
                            }}
                            onChange={(e, value) => {
                              setFieldValue('clientCode', value);
                            }}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  {...params}
                                  className={` ${classes.labelName}`}
                                  variant="outlined"
                                  margin="dense"
                                  label="Client Code"
                                  placeholder="Select Client Code"
                                />
                              </div>
                            )}
                          />
                        </Grid>
                        <Grid
                          item
                          xs={6}
                          md={4}
                          lg={3}
                          xl={2}
                          className="form-group account-guarantor"
                        >
                          <GuiAutoComplete
                            classes={{
                              option: classes.option,
                            }}
                            name="createdBy"
                            id="createdBy"
                            size="small"
                            value={values.createdBy}
                            options={createdByData}
                            getOptionLabel={(option) => {
                              return option && option?.userLoginName ? option?.userLoginName : '';
                            }}
                            renderOption={(option) => {
                              return createdByOptions(option);
                            }}
                            onChange={(e, value) => {
                              setFieldValue('createdBy', value);
                            }}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  {...params}
                                  variant="outlined"
                                  margin="dense"
                                  label="Created By"
                                  placeholder="Select Created By"
                                  className={` ${classes.labelName}`}
                                />
                              </div>
                            )}
                          />
                        </Grid>
                        <Grid
                          item
                          xs={6}
                          md={4}
                          lg={3}
                          xl={2}
                          className="form-group account-guarantor"
                        >
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                              className={` ${classes.labelName}`}
                              format="MM/dd/yyyy"
                              placeholder="MM/DD/YYYY"
                              fullWidth
                              value={values.createdDate}
                              name="createdDate"
                              onBlur={handleBlur}
                              inputVariant="outlined"
                              helperText=""
                              label="Date Created"
                              onChange={(val) => {
                                setFieldValue('createdDate', val);
                              }}
                              autoOk
                              margin="dense"
                              touched={touched?.createdDate}
                              error={Boolean(touched?.createdDate && errors?.createdDate)}
                            />
                          </MuiPickersUtilsProvider>
                          <FormHelperText variant="outlined">
                            {touched.createdDate && errors.createdDate ? errors.createdDate : ''}
                          </FormHelperText>
                        </Grid>
                        <Grid
                          item
                          xs={6}
                          md={4}
                          lg={3}
                          xl={2}
                          className="form-group account-guarantor"
                        >
                          <GuiAutoComplete
                            classes={{
                              popper: classes.popper,
                              option: classes.option,
                            }}
                            name="isDraft"
                            id="isDraft"
                            size="small"
                            options={StatusOptions}
                            required
                            value={values.isDraft}
                            getOptionLabel={(option) => {
                              return option && option?.value;
                            }}
                            onChange={(e, value) => {
                              handleChange(e);
                              setFieldValue('isDraft', value);
                            }}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  {...params}
                                  className={` ${classes.labelName}`}
                                  variant="outlined"
                                  margin="dense"
                                  // InputLabelProps={{ shrink: true }}
                                  label="Status"
                                  placeholder="Select Status"
                                />
                              </div>
                            )}
                          />
                        </Grid>
                        <Grid item md={4} lg={3} xl={3} className="form-group">
                          <div className="d-flex justify-content-lg-start justify-content-md-center">
                            <Button
                              variant="outlined"
                              className={`reset-btn mr-1 ${classes.buttonRoot}`}
                              onClick={() => {
                                setSubmit(true);
                                resetForm();
                                onClear();
                                sessionStorage.removeItem('searchTrigger');
                              }}
                            >
                              Reset
                            </Button>
                            <Button
                              variant="outlined"
                              type="submit"
                              className={`search-btn ml-1 ${classes.buttonRoot}`}
                            >
                              Search
                            </Button>
                          </div>
                        </Grid>
                      </Grid>
                    </ErrorBoundaryForComponents>
                  </div>
                </Form>
              </div>
            );
          }}
        </Formik>
        <EventTacticSearchTable
          setEventTacticCode={setEventTacticCode}
          setValue={setValue}
          searchData={searchData}
          submit={submit}
          setSubmit={setSubmit}
          setRunClicked={setRunClicked}
          setRowDataCode={setRowDataCode}
          roleDataEvent={roleDataEvent}
          setRowSelected={setRowSelected}
          setIsCopyIcon={setIsCopyIcon}
          setTriggerMaintenanceData={setTriggerMaintenanceData}
        />
        <DialogBox
          open={runClicked}
          dialogClose={closeDialog}
          title="Run a Report"
          fullWidth
          maxWidth={'sm'}
          classes={{paper: classes.dialogPaper}}
        >
          <ConfirmationForm closeDialog={closeDialog} setMainRunClicked={setMainRunClicked} />
        </DialogBox>
      </div>
    </>
  );
};
export default SearchEventContainer;
